module.exports = __webpack_public_path__ + "static/windowdepressed-b1823f9f6804d69aded1f02240cf7bc6.jpg";